import {HttpRequest,HttpMethod} from "./http";

class ProductProvider extends HttpRequest {
	// Show product for create order
	ListProductWithStock(params) {
        return this.request(HttpMethod.Post,`/api/v1/orders/product`,params );
    }


	// CRUD Product	
	ProductCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/products`,params );
	}

	ProductList(params) {
		return this.request(HttpMethod.Get,`/api/v1/products`,params );
	}

	ProductDetail(id) {
		return this.request(HttpMethod.Get,`/api/v1/products/${id}` );
	}

	ProductSkuList(params) {
		return this.request(HttpMethod.Get,`/api/v1/productssku`,params );
	}

	ProductUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/products/${id}`,params );
	}

	ProductPlatformUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/products/platform/${id}`,params );
	}
	

	ProductDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/products/${id}`);
	}


}

export default ProductProvider